import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const EditorForm = _ref => {
  let {
    elementId,
    className,
    isLoading,
    hasUpdates,
    children,
    onSubmit = () => undefined
  } = _ref;

  const handleSubmit = evt => {
    evt.preventDefault(); // Default save without publishing

    if (!isLoading && hasUpdates) onSubmit(false);
  };

  return /*#__PURE__*/_jsx("form", _objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    className: clsx(styles.container, className || ''),
    onSubmit: handleSubmit,
    children: children
  }));
};

export default EditorForm;